import React from 'react';
import { Button, Tooltip } from 'antd';

type ExportButtonProps = {
  hasSelectedUrls?: boolean;
  onClick: () => void;
};

const ExportButton = ({ hasSelectedUrls = false, onClick }: ExportButtonProps) => {
  const button = (
    <Button className="ml-2" size="small" onClick={onClick}>
      Export
    </Button>
  );

  if (hasSelectedUrls)
    return (
      <Tooltip title="The export action will run for all filtered URLs and not only a selected batch.">
        {button}
      </Tooltip>
    );

  return button;
};

export default ExportButton;
